module.exports = __webpack_public_path__ + "static/media/text_widget.7704d274.jpg";